import { createSlice } from '@reduxjs/toolkit';

const CALL_STATES = {
    IDLE: 'IDLE',
    INCOMING: "INCOMING",
    CONNECTING: "CONNECTING",
    RINGING: 'RINGING',
    IN_CALL: 'IN_CALL',
};

const initialState = {
    isSoftphoneEnabled: false,
    showSoftphone: false,
    callState: CALL_STATES.IDLE,
    activeCall: null,
    incomingCall: null,
    speedDials: [],
    voicemail: null,
    mwiStatus: null,
};

const softphoneSlice = createSlice({
    name: 'softphone',
    initialState,
    reducers: {
        setIsSoftphoneEnabled: (state, action) => {
            state.isSoftphoneEnabled = action.payload
        },
        setShowSoftphone: (state, action) => {
            state.showSoftphone = action.payload
        },
        setIncomingCall: (state, action) => {
            state.incomingCall = action.payload;
            state.callState = CALL_STATES.INCOMING;
        },
        setActiveCall: (state, action) => {
            state.activeCall = action.payload;
            state.incomingCall = null;
            state.callState = action.payload.callState ?? CALL_STATES.IN_CALL;
        },
        clearCall: (state) => {
            state.activeCall = null;
            state.incomingCall = null;
            state.callState = CALL_STATES.IDLE;
        },
        setSpeedDials: (state, action) => {
            state.speedDials = action.payload;
        },
        setVoicemail: (state, action) => {
            state.voicemail = action.payload;
        },
        setMwiStatus: (state, action) => {
            state.mwiStatus = action.payload;
        },
        resetSoftphone: () => initialState,
    },
});

export const {
    setIsSoftphoneEnabled,
    setShowSoftphone,
    setIncomingCall,
    setActiveCall,
    clearCall,
    setSpeedDials,
    setVoicemail,
    setMwiStatus,
    resetSoftphone,
} = softphoneSlice.actions;

export { CALL_STATES };

export default softphoneSlice.reducer;
